import { 
    SCORM_VERSION,
    IStringMap 
} from './index';


export class ScormError {

    public code12 : number;
    public code2004 : number;
    public errorDiagnostic : string;

    constructor(code2004?: number,code12?: number,errorDiagnostic?: string) {
        this.code12 = code12 ? code12 : 0;
        this.code2004 = code2004 ? code2004 : 0;        
        this.errorDiagnostic = errorDiagnostic ? errorDiagnostic : 'No error occurred. Last API call was successful';
    }

    public noError() : boolean {
        return (this.code12 == 0 && this.code2004 == 0);
    }

    public getErrorCode(version: SCORM_VERSION) : string {
        if(version == SCORM_VERSION.SCORM_2004) {
            return "" + this.code2004;
        } else {
            return "" + this.code12;
        }
    }

    public getErrorString(version : SCORM_VERSION, code?:string) : string {
        // Note: getErrorString is not necessarily based on the this error, hence the "code" param. see SCORM RTE spec for details
        if(!code) {
            code = this.getErrorCode(version);
        }        
        if(version == SCORM_VERSION.SCORM_2004) {
            if(code in this.code2004Map) {
                return <string>this.code2004Map[code];
            } else {
                return "Unmapped Error Code";
            }
        } else {
            if(code in this.code12Map) {
                return <string>this.code12Map[code];
            } else {
                return "Unmapped Error Code";
            }
        }
    }

    public getDiagnostic(version:SCORM_VERSION) {
        if(this.errorDiagnostic) {
            return this.errorDiagnostic;
        } else {
            return this.getErrorString(version);
        }
    }

    private code12Map : IStringMap = {
        "0"   : "No Error",
        "101" : "General Exception",
        "201" : "Invalid argument error",
        "202" : "Element cannot have children",
        "203" : "Element not an array - Cannot have count",
        "301" : "Not Initialized",
        "401" : "Not implemented error",
        "402" : "Invalid set value, element is a keyword",
        "403" : "Element is read only",
        "404" : "Element is write only",
        "405" : "Incorrect data type"
    };

    private code2004Map : IStringMap = {
        "0"   : "No Error",
        "101" : "General Exception",
        "102" : "General Initialization Failure",
        "103" : "Already Initialized",
        "104" : "Content Instance Terminated",
        "111" : "General Termination Failure",
        "112" : "Termination Before Initialization",
        "113" : "Termination After Termination",
        "122" : "Retrieve Data Before Initialization",
        "123" : "Retrieve Data After Termination",
        "132" : "Store Data Before Initialization",
        "133" : "Store Data After Termination",
        "142" : "Commit Before Initialization",
        "143" : "Commit After Termination",
        "201" : "General Argument Error",
        "301" : "General Get Failure",
        "351" : "General Set Failure",
        "391" : "General Commit Failure",
        "401" : "Undefined Data Model Element",
        "402" : "Unimplemented Data Model Element",
        "403" : "Data Model Element Value Not Intiailized",
        "404" : "Data Model Element Is Read Only",
        "405" : "Data Model Element Is Write Only",
        "406" : "Data Model Element Type Mismatch",
        "407" : "Data Model Element Value Out of Range",
        "408" : "Data Model Dependency Not Established"
    };

}